<role [state]="viewState.Details"></role>
